import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { StellarTheme } from '@lavu-pos/stellar';
import { colors, fontsStack, fontWeights } from '@lavu-pos/stellar/dist/themes';

const dialogWidth = '768px';

export const HeaderDialog = styled.div`
	font-size: 26px;
	font-weight: ${fontWeights.bold};
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;

	${({ fullScreen }) =>
		fullScreen &&
		`
		font-size: 32px;
		flex-direction: column-reverse;
		align-items: baseline;
	`}

	button {
		padding: 0;
	}

	.title {
		padding-top: ${({ fullScreen }) => (fullScreen ? 24 : 16)}px;
	}
`;

export const DialogStyle = styled(({ leftButtonContent, ...rest }) => (
	<Dialog {...rest} />
)).attrs({
	classes: {
		paper: 'customPaper',
	},
})`
	font-family: ${fontsStack.default};

	.scrollable {
		padding: 16px 16px 0;
		overflow-y: auto;
		flex: 1;

		${StellarTheme.breakpoints.up('sm')} {
			padding: 24px 24px 0;
		}
	}

	.header {
		padding-left: 0;
		margin-bottom: 32px;

		${StellarTheme.breakpoints.up('sm')} {
			padding-left: 16px;
		}
	}

	.subtitle {
		font-size: 17px;
		line-height: 24px;
		${({ fullScreen }) => !fullScreen && 'padding-right: 32px;'}
	}

	.content {
		${StellarTheme.breakpoints.up('sm')} {
			padding: 0 16px;
		}
	}

	.subtitleLink {
		color: ${colors['blue-solid']};
	}

	.actions {
		border-top: 1px solid ${colors['gray-solid']};
		padding: 8px 24px 8px 24px;
		display: grid;
		grid-template-columns: ${({ leftButtonContent }) =>
				leftButtonContent ? '90px' : ''} 1fr;
		grid-column-gap: 8px;

		button {
			text-transform: none;
		}

		${StellarTheme.breakpoints.up('sm')} {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.addButtonText {
			display: none;

			${StellarTheme.breakpoints.up('sm')} {
				display: block;
			}
		}

		.actionsRight {
			display: flex;
		}

		.modalLeftButton,
		.modalSaveButton {
			border-radius: 8px;
			border: 0;
			min-width: 0;
		}
		.modalOkButton {
			border-radius: 8px;
			border: 0;
			min-width: 0;
			background-color: #3ca5d9;
			color: #ffffff;
		}
		.modalCancelButton {
			display: none;

			${StellarTheme.breakpoints.up('sm')} {
				display: block;
				margin-right: 12px;
			}
		}
	}

	& .customPaper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		${({ fullScreen, customwidth }) =>
			!fullScreen &&
			`
			max-width: none;
			width: ${customwidth || dialogWidth};
		`}
	}

	//TODO: Remove this css when we update material-ui to latest version
	& .settings-modal-backdrop {
		touch-action: initial;
	}
`;
export const BackupParentDiv = styled.div`
	margin-top: 16px;
	.backup-text-title {
		float: left;
		width: 16%;
	}
`;
